import store from '@/store/model-store'

export default {
  deleteStore: (params) => {
    let modelStore = store.getters.model
    if (!modelStore) {
      modelStore = {}
    }
    delete modelStore['otherEstimate']['imageAndMemo'][params['sectionL']]
    store.commit('setModel', modelStore)
  }
}
